export default __webpack_public_path__ + "static/media/help_icon.44047f9a.svg";